module.exports = __webpack_public_path__ + "images/17c1be0398b5f4a0fbd948765e2887dc.png";